// @flow

import { type UserInputName } from '@tectonics/prs/user-input';
import { type UserInputValidationErrors, type UserInputValidationError } from '@tectonics/prs/validation';

export function filterUserInputValidationErrors(userInputValidationResult: UserInputValidationErrors): ImmutableArray<[UserInputName, UserInputValidationError]> {
  return ((Object.entries(userInputValidationResult).filter(item => item[1])):any);
}
